import {
  ConversationDefinition,
  ConversationEntityIdentifier,
} from '../models/conversation-definition.model';

function normaliseIdentifierArray(
  values?: ConversationEntityIdentifier[]
): ConversationEntityIdentifier[] {
  if (!values?.length) {
    return [];
  }

  return Array.from(new Set(values)).sort((a, b) => a - b);
}

export function normaliseConversationDefinition(
  definition: ConversationDefinition
): ConversationDefinition {
  return {
    locale: definition.locale,
    category: definition.category,
    type: definition.type,
    topics: normaliseIdentifierArray(definition.topics),
    cultures: normaliseIdentifierArray(definition.cultures),
    differences: normaliseIdentifierArray(definition.differences),
    courses: normaliseIdentifierArray(definition.courses),
    lessons: normaliseIdentifierArray(definition.lessons),
    tips: normaliseIdentifierArray(definition.tips),
    episodes: normaliseIdentifierArray(definition.episodes),
    deliveries: normaliseIdentifierArray(definition.deliveries),
    feature_requests: normaliseIdentifierArray(definition.feature_requests),
  };
}

export function getConversationDefinitionHash(
  definition: ConversationDefinition
): string {
  const serialised = JSON.stringify(normaliseConversationDefinition(definition));
  let hash = 5381;

  for (let i = 0; i < serialised.length; i += 1) {
    hash = (hash * 33) ^ serialised.charCodeAt(i);
  }

  return Math.abs(hash >>> 0).toString(36);
}

export function getConversationIdKey(conversationId: number | string): string {
  return `comments.conversation.${conversationId}`;
}

export function getConversationDefinitionKey(
  definition: ConversationDefinition
): string {
  return `comments.definition.${getConversationDefinitionHash(definition)}`;
}

export function getPreferredConversationKey(
  definition: ConversationDefinition,
  conversationId?: number | string
): string {
  if (conversationId !== undefined && conversationId !== null) {
    return getConversationIdKey(conversationId);
  }

  return getConversationDefinitionKey(definition);
}

export function getDraftKeyByDefinition(
  definition: ConversationDefinition
): string {
  return `comments.draft.${getConversationDefinitionHash(definition)}`;
}
